export const ALUMNI_BRIEF_DATA = {
  title: {
    ar: 'الخريجون',
    fr: 'Alumni',
    en: 'Alumni',
  },
  description: {
    ar: `"""المستقبل هو باب، والماضي هو مفتاحه.""
 فيكتور هوغو، شاعر، كاتب مسرحي، وروائي (1802-1885)
"`,
    fr: `"L'avenir est une porte, le passé en est la clé.", Victor Hugo, poète, dramaturge, écrivain et romancier (1802-1885)`,
    en: `"The future is a door, the past is its key.", Victor Hugo, poet, playwright, and novelist (1802-1885)`,
  },
  order: 1,
  attachments: [], // TODO : Attach Alumni.jpg
  image: 'alumni.jpg',
  type: 'alumni',
  isArchived: false,
};
